import { z } from 'my-zod'
import { GuestTypeEnum } from './guest-type'
import { riderModel } from './rider-model'

export const invitedGuestFragment = riderModel.pick({ id: true, email: true }).augment({
  firstName: z.string(),
  lastName: z.string(),
  guestType: GuestTypeEnum.optional()
})

export type invitedGuestFragment = z.infer<typeof invitedGuestFragment>
